// File: app.routing.ts
// Author: Joseph M Diaz
// Date: 4/24/2017
// Desc: Root routing for the app.
// Other Contributors:

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoggedOutComponent } from './logged-out/logged-out.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { NotYetImplementedComponent } from './not-yet-implemented/not-yet-implemented.component';
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { tprecmRoutes } from '../app/components/tprecm/tprecm.module';
import { RequestAccessFormComponent } from './components/tprecm/request-access-form/request-access-form.component';
import { TprecmRoutingGuard } from './components/tprecm/tprecm-routing.guard';

const appRoutes: Routes = [
   tprecmRoutes,
   { path: '', redirectTo: '/tprecm', pathMatch: 'full' },
   { path: 'request-access-form', component: RequestAccessFormComponent, canDeactivate: [TprecmRoutingGuard] },
   { path: 'logged-out', component: LoggedOutComponent },
   { path: 'not-implemented', component: NotYetImplementedComponent },
   { path: 'access-denied', component: AccessDeniedComponent },
   { path: '**', component: NotFoundComponent }
];

@NgModule({
   imports: [
      RouterModule.forRoot(appRoutes, { useHash: true, onSameUrlNavigation: 'reload' })
   ],
   exports: [
      RouterModule
   ]
})
export class AppRoutingModule { }
